// extracted by mini-css-extract-plugin
module.exports = {"app-layout":"AppLayout_app-layout__3GCsF"};